import {removeElements, ttReload} from "./auth-misc-functions.js";
import getSanitizedCookie from "./get-sanitized-cookie.js";
import {authElements, accountElements} from "./auth-account-elements.js";


/**
 * Обрабатывает ответ, полученный при отправке формы авторизации, регистрации или обновлении профиля.
 * Выводит статусные сообщения, отправляет цели в аналитику и управляет редиректами.
 *
 * @param {Object} payload - Ответ от сервера (event.data.payload)
 * @param {number|string} [payload.res] - Код успешного действия: 1 (логин/рег), 2 (данные сохранены), 3 (аватар сохранен)
 * @param {string} [payload.errors] - Текст ошибки в формате HTML-строки
 * @param {string} [payload.user_name] - Имя пользователя для вывода в сообщении об успешном входе
 * @param {string} [payload.user_info] - HTML-строка с аватаркой и именем пользователя
 * @param {string} [payload.user_pic] - URL-адрес загруженного аватара (при payload.res === 3)
 * @returns {void}
 */
const handleAccountActionResponse = (payload) => {
    if (!payload) return;

    removeElements('.g-message');

    const pinEl = accountElements.accountHeader || authElements.authRegistration; //в зависимости от того, где мы находимся (В ЛК или на странице авторизации)

    if (authElements.ttAuthBtn) {
        authElements.ttAuthBtn.disabled = false;
    }

    // Обработка ошибок
    if (payload.errors) {
        pinEl?.insertAdjacentHTML(
            'beforeend',
            `<div class="g-message g-message--error">${payload.errors}</div>`
        );
        return;
    }

    // Вспомогательная функция для перенаправления (избавляет от дублирования кода)
    const redirectOrReload = () => {
        const cookie = getSanitizedCookie('v_ttAuth_URL');
        if (cookie && cookie.length > 0) {
            window.location.href = cookie;
        } else {
            ttReload();
        }
    };

    // Обработка успешных сценариев
    switch (Number(payload.res)) {
        case 1:
            const eventAction = authElements.ttAuthBtn?.value === 'Зарегистрироваться' ? 'register' : 'login';

            if (window[`yaCounter${window["ymId"]}`]) {
                window[`yaCounter${window["ymId"]}`].reachGoal(`User - ${eventAction}`, {
                    'eventCategory': 'User',
                    'eventAction': eventAction,
                    'eventLabel': 'site',
                    'eventValue': window["ttUserId"] > 0 ? window["ttUserId"] : 0,
                });
            }

            pinEl?.insertAdjacentHTML(
                'beforeend',
                `<div class="g-message g-message--ok">Вы вошли как ${payload.user_name}.</div>`
            );

            redirectOrReload();
            break;

        case 2:
            pinEl?.insertAdjacentHTML(
                'beforeend',
                '<div class="g-message g-message--ok">Данные сохранены.</div>'
            );

            redirectOrReload();
            break;

        case 3: // загружен новый аватар
            pinEl?.insertAdjacentHTML(
                'beforeend',
                '<div class="g-message g-message--ok">Аватар сохранен</div>'
            );
            const ava = accountElements.avatar?.querySelector('img');
            if (ava) {
                ava.src = payload.user_pic;
            }
            break;
    }
}

export default handleAccountActionResponse;